<template>
<div>
    <div class="col-12 pb-5 mb-4" v-if="trackApplicationLoader">
        <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="row no-gutters body" v-else>
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background pb-4" >
            <div class="row no-gutters">
                <br />
            </div>
            <div class="row no-gutters mt-5" v-if="!currentUserProfileId || currentUserProfileId === undefined" >
                <div class="col-lg-12 pb-3">
                <div class="row no-gutters">
                    <br />
                </div>
                <div class="ml-3 mr-3 mt-lg-2 main-card">
                    <no-profile-id-component></no-profile-id-component>
                </div>
                </div>
            </div>
            <div class=" no-gutters mt-5 main-card" v-else>
                <div class="col-lg-12"> 
                    <div class="row no-gutters">
                        <br />
                    </div> 
                    <div class="mt-4 ml-lg-4 ml-md-0 d-flex justify-content-between pl-3 pl-md-0 col-lg-10">
                      <div class="pointer" @click="gotoMainPage">
                        <img src="../assets/Back.svg" class="negmargin5" alt="back"/>
                        <label class="ml-2 black fontsize20 proximanova-semibold pointer">Invite your friends </label>
                      </div>
                    </div>
                    <div>
                        <div class="pb-5">
                          <div class="card shadow mt-2 mb-3 p-4 ml-3 mr-3 d-lg-none">
                            <span class="proximanova-bold fontsize14 mt-1 black">Your Rewards</span>
                            <hr class="profhoriz mt-2 mb-2">
                            <div class="d-flex justify-content-between">
                              <span class="proximanova-semibold black60 fontsize12">Total referrals</span>
                              <span v-if="usedReferralCount > 0">
                              <span class="proximanova-bold black fontsize14" v-if="usedReferralCount < 10">0{{usedReferralCount}}</span>
                              <span class="proximanova-bold black fontsize14" v-if="usedReferralCount >= 10">{{usedReferralCount}}</span>
                              </span>
                              <span class="proximanova-bold black fontsize14" v-else>00</span>
                            </div>
                            <!-- <div class="d-flex justify-content-between mt-2">
                              <span class="proximanova-semibold black60 fontsize12">Total Reward</span>
                              <span class="proximanova-bold black fontsize14">00</span>
                            </div>
                            <div class="d-flex justify-content-between mt-2">
                              <span class="proximanova-semibold black60 fontsize12">Pending Rewards</span>
                              <span class="proximanova-bold black fontsize14">00</span>
                            </div> -->
                          </div>
                            <div class="shadow card p-4 mb-2 ml-3 mr-3 mt-lg-3" >
                              <div class="card-body homevideoslist">
                                <div class="d-flex flex-column">
                                  <!-- <span class="fontsize18 proximanova-bold blue">Spread the word and earn reward</span> -->
                                  <!-- <span class="fontsize18 proximanova-bold blue">Invite your friends</span> -->
                                  <!-- <span class="fontsize14 proximanova-semibold black80">Get <span class="proximanova-bold">₹ 100</span> for every <span class="proximanova-bold">3</span> person you refer to worknotion</span> -->
                                </div>  
                                <!-- <hr class="profhoriz mt-3 mb-3">     -->
                                <div class="d-flex flex-column">
                                  <span class="fontsize14 proximanova-semibold black80">Share your unique referral link / Code</span>
                                  <div class="col-11 p-1 mt-3 mb-3 d-flex inputborder">
                                    <input disabled
                                      class="signininput col-11 proximanova" placeholder="referral link" v-model="referralLink">
                                    <div class="col pl-0 pr-0">
                                      <button class="backgroundcolor3 white copybtn" @click="copyReferral(referralLink)">Copy</button>
                                    </div>
                                  </div>
                                  <span class="fontsize12 proximanova black60 mx-auto">( or )</span>
                                  <div class="col-md-5 col-8 p-1 mt-3 mb-3 d-flex inputborder">
                                    <input disabled
                                      class="signininput col-11 proximanova" placeholder="referral code" v-model="referralCode">
                                    <div class="col pl-0 pr-0">
                                      <button class="backgroundcolor3 white copybtn" @click="copyReferral(referralCode)">Copy</button>
                                    </div>
                                  </div>
                                  <span class="fontsize14 proximanova-semibold black80 mt-3 mb-2">Invite people to be a part of worknotion through email</span>
                                  <div class="col-md-7 col-9 pl-0 pr-0 mt-1 mb-3 d-flex ">
                                    <input type="email" name="Email" @keyup="checkemail()" autocomplete="off"
                                      class=" inputborder col-11 proximanova p-1 pl-2 pr-2" placeholder="Enter Email" v-model="referredEmail">
                                      <img src="../assets/uploadvideo.svg" width="30px" class="img-fluid ml-3" alt="uploadvideo" v-if="sendMailBtnClicked"> 
                                      <button class="blue backgroundnone borderblue1 copybtn ml-2" v-else :disabled="mailSent" @click="sendEmail">Send</button>
                                  </div>
                                  <span class="fontsize12 red proximanova">{{emailverifymessage}}</span>
                                </div>
                                <hr class="profhoriz mt-3 mb-3">
                                <div class="d-flex flex-column pb-3">
                                  <span class="fontsize14 proximanova-semibold black">How it works?</span>
                                  <span v-for="(item, index) in howitworks" :key="index">
                                  <div class="d-flex mt-3 mb-1">
                                    <img :src="item.image" alt="share" width="30px" height="30px" class="">
                                    <div class="d-flex flex-column ml-3">
                                      <span  class="fontsize14 proximanova-semibold black my-auto">{{item.title}}</span>
                                      <span  class="fontsize12 proximanova black60">{{item.description}}</span>
                                    </div>
                                  </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 pl-3 mb-5 pb-5 pr-3 middle-background d-none d-lg-block">
          <div class="row mt-5 no-gutters">
            <br />
          </div>
          <div class="row mt-5 pt-4 no-gutters main-card">
            <br />
            <div class="card shadow mt-4 p-4 col-12">
              <span class="proximanova-bold fontsize14 mt-1 black">Your Rewards</span>
              <hr class="profhoriz mt-2 mb-2">
              <div class="d-flex justify-content-between">
                <span class="proximanova-semibold black60 fontsize12">Total referrals</span>
                <span v-if="usedReferralCount > 0">
                <span class="proximanova-bold black fontsize14" v-if="usedReferralCount < 10">0{{usedReferralCount}}</span>
                <span class="proximanova-bold black fontsize14" v-if="usedReferralCount >= 10">{{usedReferralCount}}</span>
                </span>
                <span class="proximanova-bold black fontsize14" v-else>00</span>
              </div>
              <!-- <div class="d-flex justify-content-between mt-2">
                <span class="proximanova-semibold black60 fontsize12">Total Reward</span>
                <span class="proximanova-bold black fontsize14">00</span>
              </div>
              <div class="d-flex justify-content-between mt-2">
                <span class="proximanova-semibold black60 fontsize12">Pending Rewards</span>
                <span class="proximanova-bold black fontsize14">00</span>
              </div> -->
            </div>
          </div>

        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    </div>
</div>
</template>
<script>
import NoProfileIdComponent from '../components/NoProfileId.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import commonUtils from '@/js/common-utils.js'
import htttreferral from "@/js/http-referral.js";
import httpuserprofile from "@/js/http-userprofile.js"
import wndata from "@/js/wn_data.json"
import { bus } from "../main";
export default{
    components : {
        NoProfileIdComponent,
        APIerrorModal
    },
    data(){
    return{
        currentUserProfileId : null,
        displayAPIerrorModal : false,
        trackApplicationLoader : false,
        userType : null,
        userEmail : sessionUtils.getUserEmail(),
        referralLink : 'https://www.worknotion.com/invite/',
        // referralLink : 'http://localhost:8080/invite/',
        // referralLink : wndata.worknotionURL+'invite/',
        referralCode : '',
        mailSent : false,
        sendMailBtnClicked : false,
        referredEmail : '',
        usedReferralCount : 0,
        emailverifymessage : '',
        emailsList : [],
        howitworks : [
          {
            image : require('../assets/refer_share_square_line.svg'),
            title : 'Share your referral link',
            description : 'Invite your friends to join worknotion using your unique refereal link or QR Code'
          },
          {
            image : require('../assets/refer_join.svg'),
            title : 'Your friend joins Worknotion',
            // description : 'Your friend gets 10rs on their subscription when they signup using your link'
          },
          // {
          //   image : require('../assets/refer_rupee_money_bag.svg'),
          //   title : 'Earn reward',
          //   description : 'On evey 3 signup, you recdive reward of 100rs. If you claim them will transfer to your bank within 24hrs'
          // },
        ]
    }
    },
    methods:{
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        gotoMainPage() {
          this.$router.go(-1)
        },
        getReferralCode() {
          htttreferral.get('userReferral/generateReferaalCode?profileId='+this.currentUserProfileId)
          .then((response) => {
            console.log("referral code t : ", response )
            if(response.data && response.data.referalCode){
              this.referralCode = response.data.referalCode;
              this.referralLink = this.referralLink + this.referralCode;
            }
          }).catch((e) => {
            console.log(e)
          })
        },
        userReferralCounts() {
          httpuserprofile.get('userprofile/getRegisteredCount?profileId='+this.currentUserProfileId)
          .then((response) => {
            console.log("referral count : ", response )
            this.usedReferralCount = response.data.registeredCount;
          }).catch((e) => {
            console.log(e)
          })
        },
        copyReferral : function(code) {
          console.log("refer code/link : ", code)
          commonUtils.copyReferralCode(code)
        },
        // Email validations
        checkemail() {
          this.emailverifymessage = '';
          var format = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          if (this.referredEmail.length != 0) {
            if (format.test(this.referredEmail)) {
              console.log("into true : ", format.test(this.referredEmail))
              this.emailverifymessage = '';
              this.mailSent = false;
            } else {
              this.emailverifymessage = "Please enter valid Email ID"
              this.mailSent = true;
            }
          } 
        },
        sendEmail : function() {
          var vm =this;
          if(this.referredEmail){
            this.emailsList.push(this.referredEmail)
          }
          console.log("emails list : ", this.emailsList)
          if(this.emailsList && this.emailsList.length > 0){
            this.mailSent = true;
            this.sendMailBtnClicked = true;
          htttreferral.get('userReferral/sendUserReferaalCodeEmail?profileId='+this.currentUserProfileId+'&emails='+this.emailsList)
          .then((response) => {
            console.log("send email  : ", response )
            this.mailSent = false;
            this.sendMailBtnClicked = false;
            if(response.data == 'Mail Sent Success!'){
              this.referredEmail = '';
              this.emailsList = [];
              vm.$toast.success(response.data)
            }
          }).catch((e) => {
            console.log(e)
            this.mailSent = false;
            this.sendMailBtnClicked = false;
          })
          }else{
            this.emailverifymessage = "Please enter valid Email ID"
          }
        }
    },
    computed:{
        
     },
    mounted(){
        this.currentUserProfileId = sessionUtils.getUserProfileId();
        console.log(this.currentUserProfileId)
        this.getReferralCode()
        this.userReferralCounts()
    },
    beforeDestroy(){
    }
}
</script>
<style scoped>
@import '../css/vue-multiselect.min.css';
#search{
    background-color: white
}
#searchedInput{
    background-color: white !important;
}
#basic-text{
    background-color: white !important;
    border-radius: 10px 0px 0px 10px;
}
.multiselect__content-wrapper{
    max-height: 200px !important;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.mobileview{
    overflow: auto;
}   
.inputborder{
  border: 1px solid black;
  border-radius: 4px;
}
.signininput{
  border: none;
  padding: 4px 6px;
  flex: auto;
}
input::-moz-focus-inner{
  background-color: none;
}
input:focus{
  outline: none;
}
.signininput:focus{
  outline: none !important;
}
.copybtn{
  padding: 2px 15px 6px 15px;
  border: none;
  border-radius: 10px;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.mobileview::-webkit-scrollbar {
    display: none;
}

.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px;
}  
.profhoriz {
  border-top: 2px solid rgba(0,0,0,.1)
}
.pageloader {
  width: 7%;
  margin-top: 5% !important;
  margin-left: 46% !important;
  padding-bottom: 10% !important;
} 
.instanceloader{
  width: 10%;
  margin-left: 46%;
}
.list-group-item{
    padding: .25rem 0.25rem;
    border: none;
    border-radius: 5px;
}
.list-group-item:hover{
    background: rgba(31,31,31,.1);
}
#locationtext{
    border-radius: 10px 0 0 10px;
}
.imgborder1 {
  padding: 10px 15px 10px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.main-badge {
    background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%) !important;
    font-size: 12px !important;
    /* opacity: 30%; */
}
.input-group-append{
  margin-left: 0 !important;
}
.mobviewItems {
    /* font-size: 10px  !important; */
    overflow-x: auto !important;
  }
  .mobviewItems::-webkit-scrollbar {
    display: none;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px !important;
  background-color: #f0f2f5;
}
.nav-tabs {
  border-bottom: none !important;
}
#filterDropdown{
  left : unset !important;
  z-index: 3;
  width: 320px !important;
  cursor: pointer;
}
.navtoPage{
    cursor: pointer;
}
#dropdown{
    min-width: 100%;
    margin-top: 5px;
}
.dropdown-menu{
  cursor: pointer;
  position: absolute;
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.nameBlock:hover{
	color:#007AFF !important;
	text-decoration: underline;
	white-space: nowrap;
	}
.closebtnmouseover {
    border: 1px solid white;
}
.closebtnmouseover:hover {

  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  font-family: "ProximaNova-Regular" !important;
  /* border-bottom: 1px solid #757575; */
}
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
  font-family: "ProximaNova-Regular" !important;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}

/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  font-family: "ProximaNova-Regular" !important;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}
.form-control {
    border-radius: 10px;
  background-color: white !important;
  border: 1px solid #ced4da !important;
  /* border-radius: 0px 10px 10px 0px !important; */
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.btn-color{
  border-color: rgba(31, 31, 31,0.1);
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}

.sign-in-button{
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  color: #1F1F1F;
  opacity: 30%;
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1
}
.sign-in-button::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
.sign-in-button:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}

.card-body{
    padding:0 !important;
}
.card-footer{
    background-color: rgba(161, 166, 179,0.1);
    padding: unset !important;
}
.rejStatus{
     background-color: rgba(161, 166, 179,0.1);
     border-radius: 10px;
}
.statusImg{
    vertical-align: baseline;
    width: 20px;
    height: 20px;
}
.jobProfImg{
    width: 56px;
    height: 56px;
}
.activeSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.nobtn{
    color: black;
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
}
@media screen and (min-width: 550px) and (max-width : 768px){
    .jobProfImg {
        height: 50px;
    }
}
@media screen and (max-width : 550px) {
    .jobProfImg{
        height: 47px;
    }
}
</style>
